module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ack.htm"
    }
  }, [_c('em', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/pref.htm"
    }
  }, [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("1 First steps to iniquity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("2 1933: the shadow of the swastika")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("3 Towards disinheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("4 After the Nuremberg Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("5 ‘Hunted like rats’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("6 ‘The seeds of a terrible vengeance’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("7 September 1939: the trapping of Polish Jewry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("8 ‘Blood of innocents’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("9 1940: ‘a wave of evil’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("10 War in the West: terror in the East")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("11 January–June 1941: the spreading net")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("12 ‘It cannot happen!’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("13 ‘A crime without a name’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("14 ‘Write and record!’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("15 The ‘final solution’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("16 Eye-witness to mass murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("17 20 January 1942: the Wannsee Conference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("18 ‘Journey into the unknown’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("19 ‘Another journey into the unknown’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c20.htm"
    }
  }, [_vm._v("20 ‘If they have enough time, we are lost’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21.htm"
    }
  }, [_vm._v("21 ‘Avenge our tormented people’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c22.htm"
    }
  }, [_vm._v("22 From Warsaw to Treblinka: ‘these disastrous and horrible days’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c23.htm"
    }
  }, [_vm._v("23 Autumn 1942: ‘at a faster pace’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c24.htm"
    }
  }, [_vm._v("24 ‘The most horrible of all horrors’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c25.htm"
    }
  }, [_vm._v("25 September–November 1942: the spread of resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c26.htm"
    }
  }, [_vm._v("26 ‘To save at least someone’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c27.htm"
    }
  }, [_vm._v("27 ‘Help me get more trains’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c28.htm"
    }
  }, [_vm._v("28 Warsaw, April 1943: hopeless days of revolt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c29.htm"
    }
  }, [_vm._v("29 ‘The crashing fires of hell’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c30.htm"
    }
  }, [_vm._v("30 ‘To perish, but with honour’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c31.htm"
    }
  }, [_vm._v("31 ‘A page of glory… never to be written’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c32.htm"
    }
  }, [_vm._v("32 ‘Do not think our spirit is broken’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c33.htm"
    }
  }, [_vm._v("33 ‘One should like so much to live a little bit longer’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c34.htm"
    }
  }, [_vm._v("34 From the occupation of Hungary to the Normandy landings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c35.htm"
    }
  }, [_vm._v("35 ‘May one cry now?’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c36.htm"
    }
  }, [_vm._v("36 July–September 1944: the last deportations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c37.htm"
    }
  }, [_vm._v("37 September 1944: the Days of Awe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c38.htm"
    }
  }, [_vm._v("38 Revolt at Birkenau")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c39.htm"
    }
  }, [_vm._v("39 Protectors and persecutors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c40.htm"
    }
  }, [_vm._v("40 The death marches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c41.htm"
    }
  }, [_vm._v("41 The ‘tainted luck’ of survival")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/b01.htm"
    }
  }, [_c('span', {
    staticClass: "small1"
  }, [_vm._v("EPILOGUE:")]), _vm._v(" ‘I will tell the world’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/b03.htm"
    }
  }, [_c('em', [_vm._v("Notes and sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-359733d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 69
// module chunks = 0